import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';

import { Copy, Heading1 } from '../../../components/Typography';
import Header from '../../../components/Header';

export default function TailorError({ error }: { error: Error }) {
  const { t } = useTranslation();
  const [isNewVersion, setNewVersion] = useState(false);

  useEffect(() => {
    if (/ChunkLoadError/.test(error?.name)) {
      if (!isNewVersion) {
        setNewVersion(true);
      }
      // If you are certain the chunk is on your web server or CDN
      // You can try reloading the page, but be careful of recursion
      // In case the chunk really is not available
      // if (!localStorage.getItem('chunkErrorPageReloaded')) {
      //   localStorage.setItem('chunkErrorPageReloaded', 'true');
      //   window.location.reload();
      // }
    }
  }, [error, isNewVersion]);

  const handleReload = () => {
    window.location.reload();
  };

  return (
    <div
      id="ostro-tailor-error-container"
      className="grow overflow-y-auto px-7 py-6 flex flex-col"
    >
      <Header />
      <div className="flex flex-col justify-center grow">
        <div className="text-center -mt-24">
          <Heading1>{isNewVersion ? t('new_version_available_header') : t('error_header')}</Heading1>
          <Copy>{isNewVersion ? t('new_version_available_subheader') : t('error_subheader')}</Copy>
          {isNewVersion ? (
            <button
              className="bg-option my-2 p-3 rounded"
              onClick={handleReload}
            >
              {t('reload_page')}
            </button>
          ) : null}
        </div>
      </div>
    </div>
  );
}
